import React from 'react'

import PageHeader from '../components/PageHeader'
import Button from '../components/Button'
import PageSection from '../components/PageSection'
import WordpressImage from '../components/WordpressImage'

import AnimatedMetrics from '../components/AnimatedMetrics'
import SocialFollowButtons from '../components/SocialFollowButtons'
import AirstreamMap from '../components/AirstreamMap'
import InstagramImage from '../components/InstagramImage'
import AirstreamCarousel from '../components/AirstreamCarousel'

export const METRICS_AI = [
  {
    metric: '45',
    metricSuffix: '%',
    text:
      'Of people who said their concerns about online privacy and security stopped them from using the web in very practical ways.',
    reference: {
      label: 'via NTIA',
      url:
        'https://www.ntia.doc.gov/blog/2016/lack-trust-internet-privacy-and-security-may-deter-economic-and-other-online-activities'
    }
  },
  {
    metricPrefix: '$',
    metric: '1.5',
    metricSuffix: 'B',
    text: 'Amount venture capital firms invested in AI as of May 2016.',
    reference: {
      label: 'CB Insights',
      url: 'https://www.cbinsights.com/'
    }
  },
  {
    metric: '85',
    metricSuffix: '%',
    text:
      'Of customer interactions are projected to be managed without a human by 2020.',
    reference: {
      label: 'Gartner',
      url:
        'http://www.gartner.com/imagesrv/summits/docs/na/customer-360/C360_2011_brochure_FINAL.pdf'
    }
  }
]

// TODO - alt
export const AIRSTREAM_SLIDES = [
  {
    img: 'airstream-08',
    alt: ''
  },
  {
    img: 'airstream-07',
    alt: ''
  },
  {
    img: 'airstream-03',
    alt: ''
  },
  {
    img: 'airstream-01',
    alt: ''
  },
  {
    img: 'airstream-02',
    alt: ''
  },
  {
    img: 'airstream-05',
    alt: ''
  },
  {
    img: 'airstream-06',
    alt: ''
  }
]

const FAKE_INSTAGRAM = [
  { imageSrc: '/static/images/airstream/airstream-photographer.jpg' },
  { imageSrc: '/static/images/airstream/rear-airstream.jpg' },
  { imageSrc: '/static/images/airstream/airstream-coffee.jpg' }
]

function MeetingPoints ({ points }) {
  return (
    <ul className='airstream-page__tour-section__meeting-points center justify-between col-11 mx-auto mb4'>
      {points &&
        points.map(({ date, city, address }) => (
          <li
            key={city}
            className='airstream-page__tour-section__meeting-points__item white mb3'
          >
            <h1 className='airstream-page__tour-section__meeting-points__title bold mb1'>
              {date}
            </h1>
            <div className='airstream-page__tour-section__meeting-points__subtitle bold'>
              {city}
            </div>
            {address && <div className='small'>{address}</div>}
          </li>
        ))}
    </ul>
  )
}

function Instagrid ({ images }) {
  return (
    <div className='airstream-page__tour-section__instagram-grid justify-center mb4'>
      {images &&
        images.map(({ imageSrc }, idx) => (
          <InstagramImage key={idx} imageSrc={imageSrc} />
        ))}
    </div>
  )
}

export const AirstreamPage = ({
  instagramData,
  data: {
    acf: {
      heroTitleFirstLine,
      heroTitleSecondLine,
      heroContent,
      nextStop,
      heroCtaButtonLabel,

      introSectionTitle,
      introSectionContent,

      mapSectionTitle,
      meetingPoints,

      partnersSectionData,

      meetSectionTitle,
      meetSectionContent
    }
  }
}) => (
  <main className='main airstream-page maxw-xxlarge mx-auto'>
    <PageHeader
      extraClass='airstream-page__header bg-white homepage-hero-section'
      title={null}
    >
      <div className='homepage-hero-section__body'>
        <h1 className='homepage-hero-section__body__title strong mb2'>
          <div className='homepage-hero-section__body__title--small mb2'>
            {heroTitleFirstLine}
          </div>
          {heroTitleSecondLine && (
            <span className='homepage-hero-section__body__title--big blue mr1'>
              {heroTitleSecondLine}
            </span>
          )}
        </h1>
        <div
          className='homepage-hero-section__body__subtitle text-para small mb2'
          dangerouslySetInnerHTML={{ __html: heroContent }}
        />
        {nextStop && <p className='small mb3 strong'>{nextStop}</p>}
      </div>

      <div className='homepage-hero-section__body__image mb3 relative'>
        <img src='/static/images/airstream/van.svg' />
      </div>

      <div className='homepage-hero-section__actions mb4'>
        <Button
          className='homepage-hero-section__actions__button button button--primary mb2'
          onClick={() => {
            const mapElement = document.querySelector('#map')
            mapElement &&
              mapElement.scrollIntoView({
                behavior: 'smooth'
              })
          }}
        >
          {heroCtaButtonLabel}
        </Button>
      </div>
    </PageHeader>

    <PageSection extraClass='airstream-page__intro'>
      <div className='airstream-page__intro__inner py2 overflow-hidden'>
        <AirstreamCarousel slides={AIRSTREAM_SLIDES} />
      </div>
      <div className='col-12 lg-col-10 mx-auto p3'>
        <h2 className='h3 mb3 center'>{introSectionTitle}</h2>
        <div
          className='text-para mb3 maxw-text mx-auto center'
          dangerouslySetInnerHTML={{ __html: introSectionContent }}
        />
      </div>
      <div className='airstream-page__btn-container flex flex-column flex-wrap justify-center items-center'>
        <a
          href='mailto:airstream@snips.ai'
          className='airstream-page__btn-request button button--secondary button--wide mx2 mb2'
        >
          Request a Stop
        </a>
        <Button
          href='/airstream/mediakit'
          className='button button--outline button--wide mx2 mb2'
        >
          Download the Media Kit
        </Button>
      </div>
    </PageSection>

    <PageSection extraClass='airstream-page__metrics-section bg-white'>
      <AnimatedMetrics items={METRICS_AI} extraClass='py4' />
    </PageSection>

    <PageSection
      extraClass='airstream-page__tour-section bg-black white center'
      beforeSection={
        <div>
          <h1 className='airstream-page__tour-section__title h2 black mb2'>
            {mapSectionTitle}
          </h1>
          <div
            id='map'
            className='airstream-page__tour-section__google-map relative col-11 md-col-10 mx-auto'
          >
            <AirstreamMap />
          </div>
        </div>
      }
    >
      <MeetingPoints points={meetingPoints} />
      <SocialFollowButtons networks={['instagram', 'facebook', 'twitter']} />
      <h3 className='white h4 center mb3 mt2'>Explore with us @snips.ai</h3>
      {/* instagramData && <Instagrid images={instagramData} /> */}
      <Instagrid images={FAKE_INSTAGRAM} />
      <Button
        className='button button--outline button--wide mb4'
        href='https://www.instagram.com/snips.ai/'
        target='_blank'
      >
        Follow on Instagram
      </Button>
    </PageSection>

    {partnersSectionData &&
      partnersSectionData.length > 0 && (
        <PageSection extraClass='airstream-page__partners-section center bg-white'>
          <h2 className='h2 center mb4'>Partners</h2>
          <div className='maxw-large mx-auto flex flex-wrap justify-center items-center'>
            {partnersSectionData.map(({ image, label, url }, idx) => (
              <div className='flex-none p2 col-6 lg-col-4' key={idx}>
                <WordpressImage
                  className='airstream-page__partners-section__image'
                  key={idx}
                  img={image}
                />
              </div>
            ))}
          </div>
        </PageSection>
      )}

    <PageSection extraClass='airstream-page__meet-section p2'>
      <div className='bg-white mx-auto p3 center col-12 sm-col-10 md-col-8 mx-auto'>
        <h1 className='h2 mb3'>{meetSectionTitle}</h1>
        <div
          className='text-para maxw-text mb4 mx-auto'
          dangerouslySetInnerHTML={{ __html: meetSectionContent }}
        />
        <div className='flex flex-column items-center'>
          <Button
            className='button button--primary button--wide mb2'
            href='/contact'
          >
            Contact Us
          </Button>
          <Button className='button button--outline  button--wide mb2' href='/'>
            Learn More
          </Button>
        </div>
      </div>
    </PageSection>
  </main>
)

export default AirstreamPage



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/AirstreamPage.js